import React from 'react';
import { Globe, ExternalLink } from 'lucide-react';
import { PreviewUrlArtifact } from '../types';
interface Props {
  artifact: PreviewUrlArtifact;
  breadcrumb?: string;
  onViewInSession?: () => void;
}
export function PreviewUrlCard({
  artifact,
  breadcrumb,
  onViewInSession
}: Props) {
  return <div className="bg-[#1c1c22] rounded-[16px] border border-white/[0.04] overflow-hidden" data-id="element-487">
      {breadcrumb && <div className="px-4 pt-3 text-[11px] text-[#8a8680]/60 tracking-wide" data-id="element-488">{breadcrumb}</div>}
      <div className="flex items-center gap-2 px-4 pt-3 pb-2" data-id="element-489">
        <Globe size={14} className="text-[#4a9a9a]" strokeWidth={1.5} data-id="element-490" />
        <span className="text-[11px] text-[#4a9a9a] uppercase tracking-wide" data-id="element-491">Preview</span>
        <span className="text-[11px] text-[#8a8680]/60 ml-auto" data-id="element-492">{artifact.timestamp}</span>
      </div>
      <div className="px-4 pb-4" data-id="element-493">
        <h3 className="text-[14px] text-[#e8e4df] mb-1" data-id="element-494">{artifact.title}</h3>
        <p className="text-[12px] text-[#8a8680] mb-3" data-id="element-495">{artifact.description}</p>

        {/* Mock browser chrome */}
        <div className="rounded-[10px] overflow-hidden border border-white/[0.06] bg-black/30" data-id="element-496">
          <div className="flex items-center gap-2 px-3 py-2 bg-white/[0.03]" data-id="element-497">
            <div className="flex gap-1.5" data-id="element-498">
              <div className="w-2.5 h-2.5 rounded-full bg-[#e8a84c]/60" data-id="element-499" />
              <div className="w-2.5 h-2.5 rounded-full bg-[#4a9a9a]/60" data-id="element-500" />
              <div className="w-2.5 h-2.5 rounded-full bg-[#8a8680]/40" data-id="element-501" />
            </div>
            <div className="flex-1 text-[10px] text-[#8a8680] font-mono truncate" data-id="element-502">{artifact.url}</div>
          </div>
          <div className="aspect-[16/10] bg-gradient-to-br from-white/[0.02] to-transparent flex items-center justify-center" data-id="element-503">
            <div className="text-center" data-id="element-504">
              <div className="w-12 h-12 rounded-full bg-[#4a9a9a]/10 border border-[#4a9a9a]/30 mx-auto mb-2 flex items-center justify-center" data-id="element-505">
                <Globe size={18} className="text-[#4a9a9a]" strokeWidth={1.5} data-id="element-506" />
              </div>
              <div className="text-[11px] text-[#8a8680]" data-id="element-507">Live preview</div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3 mt-3" data-id="element-508">
          <button className="flex items-center gap-1.5 text-[11px] text-[#4a9a9a] hover:text-[#5ab0b0] transition-colors" data-id="element-509">
            <ExternalLink size={11} strokeWidth={1.8} data-id="element-510" />
            Open in new tab
          </button>
          {onViewInSession && <button onClick={onViewInSession} className="text-[11px] text-[#8a8680] hover:text-[#4a9a9a] transition-colors" data-id="element-511">
              View in session →
            </button>}
        </div>
      </div>
    </div>;
}